module.exports = __webpack_public_path__ + "img/polar-watermark.c4a15e65.png";